var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFacebook = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Facebook",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 44.745,
    viewBox: "0 0 45 44.745",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0079c0;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4341",
    "data-name": "Path 4341",
    className: "cls-1",
    d: "M45,22.509A22.5,22.5,0,1,0,18.984,44.745V29.016H13.271V22.509h5.713V17.55c0-5.641,3.359-8.757,8.5-8.757a34.586,34.586,0,0,1,5.037.44v5.539H29.682c-2.8,0-3.667,1.735-3.667,3.515v4.222h6.24l-1,6.507H26.016V44.745A22.512,22.512,0,0,0,45,22.509Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFacebook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/facebook.6aee8cd7679d77661f137c07fdaad865.svg";